import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=74006456"
import script from "./Outbound.vue?vue&type=script&lang=js"
export * from "./Outbound.vue?vue&type=script&lang=js"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=74006456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports